import { render, staticRenderFns } from "./SalaryComponents.vue?vue&type=template&id=91434812&scoped=true"
import script from "./SalaryComponents.vue?vue&type=script&lang=js"
export * from "./SalaryComponents.vue?vue&type=script&lang=js"
import style0 from "./SalaryComponents.vue?vue&type=style&index=0&id=91434812&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91434812",
  null
  
)

export default component.exports